import React from "react";
import "./styles.css";

const FirstQuestionComponent = ({ questionResponse }) => {
  const onClickNewPatient = () => {
    questionResponse(2);
  };

  const onClickOldPatient = () => {
    questionResponse(5);
  };

  return (
    <div className="containerFirstQuestion">
      <h1 className="questionAppointment">¿Es la primera vez que vienes?</h1>
      <div className="appointmentButtonsClient">
        <button className="buttonOptionClient" onClick={onClickNewPatient}>
          Sí, es mi primera vez
        </button>
        <button className="buttonOptionClient" onClick={onClickOldPatient}>
          No, ya soy paciente
        </button>
      </div>
    </div>
  );
};

export default FirstQuestionComponent;
